<template>
<div>
	
	<field label="Item Number"
		:col-class="colClass"
		:align-label-right="true"
		v-model="payload.item_number"
		:readonly="isFinalized"
		v-on:change="fieldChanged">
	</field>

	<field label="Spec Number"
		:col-class="colClass"
		:align-label-right="true"
		v-model="payload.spec_number"
		:readonly="isFinalized"
		v-on:change="fieldChanged">
	</field>

	<field label="Component Description"
		:align-label-right="true"
		:col-class="colClass"
		v-model="payload.description"
		:params="{type:'textarea',maxLength:250}"
		:readonly="isFinalized"
		v-on:change="fieldChanged">
	</field>

	<field label="Qty"
		:col-class="colClass"
		:align-label-right="true"
		v-model="payload.qty"
		:readonly="isFinalized"
		v-on:change="fieldChanged">
	</field>

	<field label="Qty Unit"
		:col-class="colClass"
		:align-label-right="true"
		v-model="payload.qty_unit"
		:params="{
			type: 'select',
			options: $store.unitMeasurementOptions
		}"
		:readonly="isFinalized"
		v-on:change="fieldChanged">
	</field>

	<field label="Calculation Method"
		:col-class="colClass"
		:align-label-right="true"
		v-model="payload.is_reverse_calculated"
		:readonly="isFinalized"
		:params="{
			type: 'select',
			options: [
				{text: 'Component Price = Unit Price',value: 0},
				{text: 'Component Price = Total Price',value: 1}
			]
		}"
		v-on:change="fieldChanged">

	</field>

</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"

export default {
	name: "ComponentDetailFields",
	components: {
		Field
	},
	props: [
		"values",
		"colClass",
		"isFinalized"
	],
	data() {
		return {
			payload: {
				item_number: null,
				spec_number: null,
				description: null,
				qty: 1,
				qty_unit: null,
				is_reverse_calculated: 0
			}
		}
	},
	watch: {
		values() {
			this.setValues()
		}
	},
	methods: {
		setValues() {
			let vm = this

			Object.keys(this.values).forEach(key => {
				vm.payload[key] = vm.values[key]
			})
		},
		fieldChanged() {
			let vm = this

			this.$nextTick(() => {
				vm.$emit("change",vm.payload)
			})
		}
	},
	created() {
		let vm = this
		this.setValues()

		if (this.$store.unitMeasurementOptions.length == 0) {
			this.fetchMeasurementUnits().then(response => {
				vm.setValues()
			})
		}
	}
}
</script>